export default {
    heading: "{name}'s m-Card",
    shared_note: 'Shared with you by the patient. Available until {date}.',
    none_shared: 'Nothing is listed in this section.',
    download_pdf: 'Download PDF',
    sections: {
        allergies: 'Allergies',
        medical_conditions: 'Medical conditions',
        chronic_conditions: 'Chronic conditions',
        procedures: 'Procedures and surgeries',
        medications: 'Medications',
        vaccines: 'Vaccines',
        primary_care_provider: 'Primary care provider',
        emergency_contact: 'Emergency contact',
        family_history: 'Family history',
        pharmacy: 'Preferred pharmacy',
    },
    expired_heading: 'This link has expired',
    expired_message: 'Ask the patient to share their m-Card again.',
    not_found_heading: 'Link not found',
    not_found_message:
        'This link is invalid, was shared with a different account, or has been revoked. Sign in with the account that uses the NPI the patient approved.',
    errors: {
        load_failed: 'We could not load this m-Card. Please try again.',
        pdf_failed: 'We could not download the PDF. Please try again.',
    },
}
